module.exports = __webpack_public_path__ + "static/media/Arrow-right.834be254.svg";